module.exports = __webpack_public_path__ + "img/yaamava-logo.0ba7dbb8.svg";